<template>
  <g>
    <g v-if="room.number === 0">
      <rect x="100" y="100" :height="wholeH / 2" :width="wholeW / 3" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <Plant :x="105" :y="320" :transform="{'transform': 'rotate(180deg)'}"/>
      <RoomName :x="105" :y="105" :room="room"/>
      <Chair v-for="i in 4" :key="i + '-1'" :x="150 + 64 * i" :y="140" :transform="{'transform': 'rotate(180deg)'}" :room="room" :table="table(0)"/>
      <Chair v-for="i in 4" :key="i + '-2'" :x="150 + 64 * i" :y="320" :transform="''" :room="room" :table="table(0)"/>
      <LongTable :x="185" :y="200" :transform="''"/>
      <TableName :x="190" :y="205" :width="200" :table="table(0)"/>
      <BulletinBoard :x="500" :y="225" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 1">
      <rect x="100" :y="wholeH / 2 + 100" :height="wholeH / 2" :width="wholeW / 3" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <Plant :x="105" :y="620" :transform="{'transform': 'rotate(180deg)'}"/>
      <RoomName :x="105" :y="wholeH / 2 + 105" :room="room"/>
      <Chair v-for="i in 4" :key="i + '-3'" :x="150 + 64 * i" :y="440" :transform="{'transform': 'rotate(180deg)'}" :room="room" :table="table(1)"/>
      <Chair v-for="i in 4" :key="i + '-4'" :x="150 + 64 * i" :y="620" :transform="''" :room="room" :table="table(1)"/>
      <LongTable :x="185" :y="500" :transform="''"/>
      <TableName :x="190" :y="505" :width="200" :table="table(1)"/>
      <BulletinBoard :x="500" :y="525" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 2">
      <rect :x="wholeW / 3 + 100" y="100" :height="wholeH / 2" :width="wholeW / 2" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <Plant :x="1200" :y="110" :transform="{'transform': 'rotate(180deg)'}"/>
      <!-- <Plant :x="1200" :y="220" :transform="{'transform': 'rotate(180deg)'}"/> -->
      <Plant :x="1200" :y="320" :transform="{'transform': 'rotate(180deg)'}"/>
      <RoomName :x="wholeW / 3 + 105" :y="105" :room="room"/>
      <Chair v-for="i in 2" :key="i + '-5'" :x="560 + 64 * i" :y="140" :transform="{'transform': 'rotate(180deg)'}" :table="table(2)"/>
      <Chair v-for="i in 2" :key="i + '-6'" :x="560 + 64 * i" :y="320" :transform="''" :table="table(2)"/>
      <Table :x="605" :y="200" :transform="''"/>
      <TableName :x="610" :y="205" :width="150" :table="table(2)"/>
      <Chair v-for="i in 2" :key="i + '-7'" :x="760 + 64 * i" :y="140" :transform="{'transform': 'rotate(180deg)'}" :table="table(3)"/>
      <Chair v-for="i in 2" :key="i + '-8'" :x="760 + 64 * i" :y="320" :transform="''" :table="table(3)"/>
      <Table :x="805" :y="200" :transform="''"/>
      <TableName :x="810" :y="205" :width="150" :table="table(3)"/>
      <Chair v-for="i in 2" :key="i + '-9'"  :x="960 + 64 * i" :y="140" :transform="{'transform': 'rotate(180deg)'}" :table="table(4)"/>
      <Chair v-for="i in 2" :key="i + '-10'" :x="960 + 64 * i" :y="320" :transform="''" :table="table(4)"/>
      <Table :x="1005" :y="200" :transform="''"/>
      <TableName :x="1010" :y="205" :width="150" :table="table(4)"/>
      <BulletinBoard :x="1200" :y="225" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 3">
      <rect :x="wholeW / 3 + 100" :y="wholeH / 2 + 100" :height="wholeH / 4" :width="wholeW / 4" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <RoomName :x="wholeW / 3 + 105" :y="wholeH / 2 + 105" :room="room"/>
      <Chair :x="635" :y="455" :transform="{'transform': 'rotate(90deg)'}" :table="table(5)"/>
      <Chair :x="810" :y="455" :transform="{'transform': 'rotate(270deg)'}" :table="table(5)"/>
      <SmallTable :x="695" :y="430" :transform="''"/>
      <TableName :x="700" :y="435" :width="100" :table="table(5)"/>
      <BulletinBoard :x="860" :y="410" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 4">
      <rect :x="wholeW / 3 + 100" :y="wholeH / 2 + wholeH / 4 + 100" :height="wholeH / 4" :width="wholeW / 4" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <RoomName :x="wholeW / 3 + 105" :y="wholeH / 2 + wholeH / 4 + 105" :room="room"/>
      <Chair :x="635" :y="605" :transform="{'transform': 'rotate(90deg)'}" :table="table(6)"/>
      <Chair :x="810" :y="605" :transform="{'transform': 'rotate(270deg)'}" :table="table(6)"/>
      <SmallTable :x="695" :y="580" :transform="''"/>
      <TableName :x="700" :y="585" :width="100" :table="table(6)"/>
      <BulletinBoard :x="860" :y="560" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 5">
      <rect :x="wholeW / 3 + wholeW / 4 + 100" :y="wholeH / 2 + 100" :height="wholeH / 2" :width="wholeW / 4" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <RoomName :x="wholeW / 3 + wholeW / 4 + 105" :y="wholeH / 2 + 105" :room="room"/>
      <Chair :x="1100" :y="610 - 170" :transform="{'transform': 'rotate(90deg)'}" :table="table(7)"/>
      <Chair :x="955"  :y="525" :transform="{'transform': 'rotate(180deg)'}" :table="table(7)"/>
      <SmallTable :x="1155" :y="415" :transform="''"/>
      <TableName :x="1160" :y="420" :width="100" :table="table(7)"/>
      <Chair :x="1040" :y="610" :transform="{'transform': 'rotate(270deg)'}" :table="table(8)"/>
      <SmallTable :x="930" :y="585" :transform="''"/>
      <TableName :x="935" :y="590" :width="100" :table="table(8)"/>
      <Chair :x="1180" :y="525" :transform="''" :table="table(8)"/>
      <BulletinBoard :x="1200" :y="630" :room_number="room.number"/>
    </g>
    <g v-if="room.number === 6">
      <rect :x="wholeW / 3 + wholeW / 2 + 100" y="100" :height="wholeH" :width="wholeW / 6" :fill="fill" :stroke-width="strokeWidth" :stroke="stroke"/>
      <RoomName :x="wholeW / 3 + wholeW / 2 + 105" :y="105" :room="room"/>
      <Chair v-for="i in 7" :key="i + '-11'" :x="1285" :y="125 + (64 * i)" :transform="{'transform': 'rotate(90deg)'}" :table="table(9)"/>
      <Chair v-for="i in 7" :key="i + '-12'" :x="1435" :y="125 + (64 * i)" :transform="{'transform': 'rotate(270deg)'}" :table="table(9)"/>
      <LongestTable :x="1345" :y="150" :transform="''"/>
      <TableName :x="1350" :y="155" :width="80" :table="table(9)"/>
      <BulletinBoard :x="1440" :y="110" :room_number="room.number"/>
    </g>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import Plant from '@/views/DashBoard/VirtualOffice/Interior/Plant'
import Monitor from '@/views/DashBoard/VirtualOffice/Interior/Monitor'
import Chair from '@/views/DashBoard/VirtualOffice/Interior/Chair'
import LongTable from '@/views/DashBoard/VirtualOffice/Interior/LongTable'
import Table from '@/views/DashBoard/VirtualOffice/Interior/Table'
import SmallTable from '@/views/DashBoard/VirtualOffice/Interior/SmallTable'
import LongestTable from '@/views/DashBoard/VirtualOffice/Interior/LongestTable'
import RoomName from '@/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/RoomName'
import TableName from '@/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/TableName'
import BulletinBoard from '@/views/DashBoard/VirtualOffice/Interior/BulletinBoard'
export default {
  name: 'ParentRoom',
  componentName: 'ParentRoom',
  props: ['room'],
  components: {
    Plant,
    Monitor,
    Chair,
    LongTable,
    Table,
    SmallTable,
    LongestTable,
    RoomName,
    TableName,
    BulletinBoard
  },
  computed: {
    table () {
      self = this
      return function (tableNum) {
        let ret = null
        for (const t of self.room.table_name) {
          if (tableNum === t.number) {
            ret = t
          }
        }
        return ret
      }
    },
  },
  data () {
    return {
      stroke: '#fff',
      strokeWidth: 10,
      fill: '#505b66',
      wholeH: 600,
      wholeW: 1400,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/ParentRoom.vue